import { Component, OnInit, NgZone, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import { QueryParamsModel, LayoutUtilsService } from 'app/core/_base/crud';
import moment from 'moment';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { ChartsService } from '../../../charts/charts-service/charts.service';
import { DashboardExpiryService } from '../dashboard-expiry-service/dashboard-expiry.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { MatDialog } from '@angular/material';
import { DashboardExpiryConfigComponent } from '../dashboard-expiry-config/dashboard-expiry-config.component';
import { SysConfigService } from '../../../cau-hinh/sys-config/sys-config-service/sys-config.service';
am4core.useTheme(am4themes_material);
@Component({
  selector: 'kt-dashboard-expiry-card',
  templateUrl: './dashboard-expiry-card.component.html',
  styleUrls: ['./dashboard-expiry-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})
export class DashboardExpiryCardComponent implements OnInit {
  MESSAGE_ERROR = "Không thể tải danh sách";
  result: number = 0;
  loadingUserConfig = new BehaviorSubject<boolean>(false);
  userConfig: any = {};

  constructor(
    private changeDetect: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService,
    private service: DashboardExpiryService,
    public  dialog : MatDialog,
    private userConfigService: SysConfigService,
    

  ) {}
  ngOnInit() {  
    this.loadUserConfig();
  }
  async loadUserConfig() {
		this.loadingUserConfig.next(true);
		await this.userConfigService.getUserConfig().subscribe(
			res => {
				if (res && res.status === 1 && res.data) {
					this.userConfig = res.data;
				}
				this.loadingUserConfig.next(false);
				this.handleAPIData();
				this.changeDetect.detectChanges();
			},
			error => {
				console.error('Error loading user config:', error);
				this.loadingUserConfig.next(false);
				this.handleAPIData();
				this.changeDetect.detectChanges();
			}
		);
	}
	
  async handleAPIData(){
    let productIds;
		let productTypeIds;
		let outOfDate;

    if (this.userConfig.find(x => x.ConfigKey === 'ETIdHH_Expiry')) {
				productIds = (JSON.parse(this.userConfig.find(x => x.ConfigKey === 'ETIdHH_Expiry').ConfigValue) || []);
			}
    if (this.userConfig.find(x => x.ConfigKey === 'ETListLoaiHH_Expiry')) {
      productTypeIds = (JSON.parse(this.userConfig.find(x => x.ConfigKey === 'ETListLoaiHH_Expiry').ConfigValue) || []);
    }
    if (this.userConfig.find(x => x.ConfigKey === 'ETOutDate_Expiry')) {
      outOfDate = this.userConfig.find(x => x.ConfigKey === 'ETOutDate_Expiry').ConfigValue || null;
    }
    var res = await this.service.getData(productTypeIds, productIds, outOfDate).toPromise();

    if (!res || res.status == 0){
      this.layoutUtilsService.showErorr(this.MESSAGE_ERROR);
      return;
    }
    this.result = res.data.length; 
    this.changeDetect.detectChanges();
	}
  changeDetectView() {
    if (!(this.changeDetect as ViewRef).destroyed) {
      this.changeDetect.detectChanges()
    }
  }
  f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 0);
	}

  openModal(){
      const dialogRef = this.dialog.open(
          DashboardExpiryConfigComponent, {
          data: {},
        }
      );
      dialogRef.afterClosed().subscribe((res) => {});
    }
}